import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

import QuestionnaireStepHeader from './QuestionnaireStepHeader';

const useStyles = makeStyles({
  container: {
    height: 400,
    display: 'flex',
    alignItems: 'center',
  },
});

const QuestionnaireIntro = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <QuestionnaireStepHeader
        label={t(
          'Please take two minutes of your time to allow customizing our platform to your needs.',
        )}
      />
    </div>
  );
};

export default QuestionnaireIntro;
